import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

import { onlyMoney } from 'hooks/Pipe';
import { WithApp } from 'contexts/appContext';
import { wsGet, wsGetAll, wsUpdate, wsCreate } from 'services/WService';
import { ConstantPermissions } from 'contexts/useConstant';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import Provider from './Provider';
import Reward from './Reward';
import Goal from './Goal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: '500'
  },
  approved: {
    fontWeight: '500',
    marginBottom: '3px',
    fontSize: '15px'
  },
  general: {
    marginTop: '15px',
    '& h6': {
      fontSize: '11px',
      marginBottom: '0px'
    }
  }
});

const defaultData = {
  period_date: moment().format('YYYY-MM'),
  start_date: moment().format('YYYY-MM-DD'),
  end_date: moment().endOf('month').format('YYYY-MM-DD')
};

export default WithApp(function IncentiveNewUpdate(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const { id } = useParams();
  const [idInc, setIdInc] = useState(id);
  const [initialData, setInitialData] = useState({});
  const [incentive, setIncentive] = useState(defaultData);
  const [zones, setZones] = useState([]);
  const [businessPartners, setBusinessPartners] = useState([]);

  async function getIncentive(idIncentive) {
    let response = await wsGet('com/incentive', idIncentive);
    if (response.success) {
      setIncentive(response.data);
      setInitialData(response.data);
    }
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  const handleChange = (e) => {
    setIncentive({ ...incentive, [e.target.name]: e.target.value });
  };

  async function saveIncentive() {
    let response = await wsCreate('com/incentive', incentive);
    if (response.success) {
      window.history.replaceState('', '', `${response.data.id}/editar`);
      getIncentive(response.data.id);
      setIdInc(response.data.id);
    }
  }

  async function updateIncentive(idIncentive) {
    for (let key in incentive) {
      if (initialData[key] == incentive[key]) {
        delete incentive[key];
      }
    }
    let response = await wsUpdate('com/incentive', idIncentive, incentive);
    if (response.success) {
      getIncentive(idIncentive);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function listBusinessPartners() {
    let response = await wsGetAll('base/business-partner?CardType=S&QryGroup1=Y');
    if (response.success) setBusinessPartners(response.data);
  }

  useEffect(() => {
    listBusinessPartners();
    listZones();
    if (id) getIncentive(id);
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary" pointer="true">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Datos generales</h4>
          </CardHeader>
          <CardBody>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (incentive.id) {
                  updateIncentive(incentive.id);
                } else {
                  saveIncentive();
                }
              }}
            >
              <GridContainer>
                <GridItem xs={12} md={3} lg={2}>
                  <TextField
                    label="Periodo"
                    type="month"
                    name="period_date"
                    value={moment(incentive.period_date).format('YYYY-MM') || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={3}>
                  <Autocomplete
                    key={businessPartners}
                    disableClearable
                    options={businessPartners}
                    getOptionLabel={(option) => option.CardName}
                    defaultValue={
                      businessPartners.find(
                        (item) => item.id == incentive.base_business_partner_id
                      ) || undefined
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Socio de Negocio" margin="normal" required />
                    )}
                    onChange={(e, item) =>
                      setIncentive({ ...incentive, base_business_partner_id: item.id })
                    }
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={2}>
                  <TextField
                    label="Fecha inicio"
                    type="date"
                    name="start_date"
                    value={moment(incentive.start_date).format('YYYY-MM-DD') || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={2}>
                  <TextField
                    label="Fecha final"
                    type="date"
                    name="end_date"
                    value={moment(incentive.end_date).format('YYYY-MM-DD') || ''}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={2}>
                  <FormControl fullWidth margin="normal" size="small" required>
                    <InputLabel>Zona</InputLabel>
                    <Select
                      value={incentive.base_zone_id || ''}
                      inputProps={{
                        name: 'base_zone_id',
                        onChange: handleChange
                      }}
                    >
                      {zones.map((zone, i) => {
                        return (
                          <MenuItem value={zone.id} key={i}>
                            {zone.description}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} md={3} lg={2}>
                  <TextField
                    label="Recompenza supervisor"
                    type="number"
                    name="supervisor_reward"
                    value={incentive.supervisor_reward || ''}
                    onChange={handleChange}
                    onKeyPress={onlyMoney}
                    margin="normal"
                    size="small"
                    fullWidth
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={2}>
                  <TextField
                    label="Recompenza jefe"
                    type="number"
                    name="sale_manager_reward"
                    value={incentive.sale_manager_reward || ''}
                    onChange={handleChange}
                    onKeyPress={onlyMoney}
                    margin="normal"
                    size="small"
                    fullWidth
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={3}>
                  <TextField
                    label="Descripción"
                    name="description"
                    value={incentive.description || ''}
                    onChange={handleChange}
                    multiline
                    margin="normal"
                    size="small"
                    fullWidth
                  />
                </GridItem>
                <GridItem xs={12} md={3} lg={3}>
                  <TextField
                    label="Comentario"
                    name="comments"
                    value={incentive.comments || ''}
                    onChange={handleChange}
                    multiline
                    margin="normal"
                    size="small"
                    fullWidth
                  />
                </GridItem>
              </GridContainer>

              {incentive.id ? (
                <GridContainer className={classes.general}>
                  <GridItem xs={12}>
                    <span className={classes.approved}>
                      Estado de aprobación:
                      <span
                        style={{
                          fontSize: '13px',
                          color: incentive.approved === 'Y' ? 'green' : 'red',
                          marginLeft: '8px'
                        }}
                      >
                        ({incentive.approved === 'Y' ? 'Aprobado' : 'No aprobado'})
                      </span>
                    </span>
                    <hr style={{ margin: 0 }} />
                  </GridItem>
                  <GridItem xs={12} md={2} lg={2}>
                    <h6>Fecha aprobación</h6>
                    <span>
                      {incentive.approved_date
                        ? moment(incentive.approved_date).format('YYYY-MM-DD')
                        : '-'}
                    </span>
                  </GridItem>
                  <GridItem xs={12} md={2} lg={2}>
                    <h6>Creado por</h6>
                    <span>{incentive.created_user_name || '-'}</span>
                  </GridItem>
                  <GridItem xs={12} md={2} lg={2}>
                    <h6>Aprobado por</h6>
                    <span>{incentive.approved_user_name || '-'}</span>
                  </GridItem>
                </GridContainer>
              ) : undefined}

              <GridContainer>
                <GridItem xs={12}>
                  {incentive.id || idInc ? (
                    <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_SHOW}>
                      <Button
                        type="submit"
                        color={props.themeContext.buttonColorWarning}
                        style={{ float: 'right' }}
                      >
                        Actualizar
                      </Button>
                    </AllowedGuard>
                  ) : (
                    <AllowedGuard permission={ConstantPermissions.LOGI_MARKS_SHOW}>
                      <Button
                        type="submit"
                        color={props.themeContext.buttonColorSuccess}
                        style={{ float: 'right' }}
                      >
                        Guardar
                      </Button>
                    </AllowedGuard>
                  )}
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
      {incentive.id ? (
        <>
          <GridItem xs={12}>
            <Provider
              incentive={incentive}
              showNotify={showNotify}
              reload={() => getIncentive(incentive.id)}
            />
          </GridItem>

          {/* Recompensas */}
          <GridItem xs={12}>
            <Reward
              incentive={incentive}
              showNotify={showNotify}
              reload={() => getIncentive(incentive.id)}
            />
          </GridItem>

          {/* Metas */}
          <GridItem xs={12}>
            <Goal
              incentive={incentive}
              showNotify={showNotify}
              reload={() => getIncentive(incentive.id)}
            />
          </GridItem>
        </>
      ) : undefined}
    </GridContainer>
  );
});
